import { Box, styled } from '@mui/material';

export const StripeTextFieldContainer = styled(Box)(() => ({
  '& .StripeElement': {
    padding: 0,
    zIndex: 10,
  },
}));
